export default "/assets/images/the-rookie-parent-crop.webp?c943fc1615bc6bc900fb4192314f3f8a";